var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentVerify = function SvgDocumentVerify(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 120 120",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F7F9FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#DocumentVerify_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.514 84.343a3 3 0 0 1-3-3V42.772a3 3 0 0 1 3-3h28.971a3 3 0 0 1 3 3v38.57a3 3 0 0 1-3 3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464B52",
    fillRule: "evenodd",
    d: "M37.629 85.114a4.8 4.8 0 0 0 4.8 4.8h3.081a.6.6 0 0 1 0 1.2H42.43a6 6 0 0 1-6-6v-3.037a.6.6 0 1 1 1.2 0zm-.6-41.106a.6.6 0 0 1-.6-.6v-3.037a6 6 0 0 1 6-6h3.081a.6.6 0 0 1 0 1.2H42.43a4.8 4.8 0 0 0-4.8 4.8v3.037a.6.6 0 0 1-.6.6m36.86 46.506a.6.6 0 0 1 .6-.6h3.083a4.8 4.8 0 0 0 4.8-4.8v-3.037a.6.6 0 1 1 1.2 0v3.037a6 6 0 0 1-6 6H74.49a.6.6 0 0 1-.6-.6m0-55.543a.6.6 0 0 1 .6-.6h3.083a6 6 0 0 1 6 6v3.037a.6.6 0 0 1-1.2 0v-3.037a4.8 4.8 0 0 0-4.8-4.8H74.49a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED1FF",
    fillRule: "evenodd",
    d: "M67.046 51.554a7 7 0 0 1-1.238 3.986 7.03 7.03 0 0 1-5.805 3.061 7.054 7.054 0 0 1-7.05-7.05c0-3.882 3.16-7.04 7.048-7.04 3.886 0 7.045 3.16 7.045 7.042",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#241515",
    fillRule: "evenodd",
    d: "M59.813 43.684a1.372 1.372 0 1 1 0 2.744 1.372 1.372 0 0 1 0-2.744",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#241515",
    fillRule: "evenodd",
    d: "M58.716 44.781a.823.823 0 1 1 0 1.647.823.823 0 0 1 0-1.647M60.91 43.135a.823.823 0 1 1 0 1.646.823.823 0 0 1 0-1.646",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#241515",
    fillRule: "evenodd",
    d: "M59.539 42.586a1.098 1.098 0 1 1 0 2.195 1.098 1.098 0 0 1 0-2.195",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#241515",
    fillRule: "evenodd",
    d: "M58.716 43.684a.823.823 0 1 1 0 1.646.823.823 0 0 1 0-1.646M61.459 44.232a.823.823 0 1 1 0 1.647.823.823 0 0 1 0-1.647",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#241515",
    fillRule: "evenodd",
    d: "M60.91 45.33a.823.823 0 1 1 0 1.646.823.823 0 0 1 0-1.646",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#241515",
    fillRule: "evenodd",
    d: "M60.01 45.95c1.91 0 3.46 1.43 3.46 3.193 0 1.762-1.55 3.193-3.46 3.193s-3.461-1.43-3.461-3.193c0-1.762 1.55-3.193 3.46-3.193",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#5981E3",
    fillRule: "evenodd",
    d: "M65.808 55.54a7.03 7.03 0 0 1-5.805 3.061 7.05 7.05 0 0 1-5.824-3.082c.742-.36 2.729-1.191 5.745-1.634v-.013l.045.007.044-.007v.013c3.091.456 5.097 1.322 5.795 1.655",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#A25028",
    fillRule: "evenodd",
    d: "M61.365 52.133h-2.733v2.633a1.366 1.366 0 1 0 2.733 0z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C27448",
    fillRule: "evenodd",
    d: "M62.516 48.835a1.43 1.43 0 0 0-.363-1.06 1.36 1.36 0 0 0-1.006-.45h-2.344c-.38 0-.744.162-1.005.45-.259.286-.392.669-.364 1.06.08 1.125.186 2.644.261 3.717.052.736.65 1.307 1.37 1.307h1.82c.718 0 1.317-.569 1.368-1.307.077-1.073.184-2.592.263-3.717",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#631F0A",
    fillRule: "evenodd",
    d: "M61.211 50.486a.2.2 0 0 0-.057-.143.2.2 0 0 0-.282 0 .2.2 0 0 0-.059.143v.323a.2.2 0 0 0 .058.141.2.2 0 0 0 .282 0 .2.2 0 0 0 .058-.14zm-2 0a.2.2 0 0 0-.057-.143.2.2 0 0 0-.144-.058.2.2 0 0 0-.14.058.2.2 0 0 0-.058.143v.323a.199.199 0 0 0 .199.199.2.2 0 0 0 .143-.058.2.2 0 0 0 .057-.14z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#631F0A",
    d: "M60.013 52.426c-.462 0-.904-.17-1.246-.483a.115.115 0 0 1-.007-.163.117.117 0 0 1 .163-.008 1.612 1.612 0 0 0 2.182 0 .113.113 0 0 1 .162.008c.043.047.04.12-.007.163-.34.312-.782.483-1.247.483"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#A25028",
    fillRule: "evenodd",
    d: "M58.166 47.525s-.452.554.052 1.137c.504.582 1.116.173 1.595.509q.138.204.295.361c1.23 1.247 3.25-.811 1.892-1.917-.672-.546-1.86-.784-3.834-.09",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#241515",
    fillRule: "evenodd",
    d: "M58.145 47.107s-.252.692.296 1.241c.55.549 1.125.28 1.647.597.823 1.05 1.92 1.05 2.77.728 0-.002.36-4.11-4.713-2.566",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.514 80.78a3 3 0 0 1-3-3V46.2a3 3 0 0 1 3-3h23.485a3 3 0 0 1 3 3v31.58a3 3 0 0 1-3 3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED1FF",
    fillRule: "evenodd",
    d: "M111.663 52.87a6.2 6.2 0 0 1-1.096 3.53 6.23 6.23 0 0 1-5.139 2.71 6.24 6.24 0 0 1-5.156-2.73 6.2 6.2 0 0 1-1.086-3.512 6.243 6.243 0 0 1 6.24-6.235 6.245 6.245 0 0 1 6.237 6.237",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#5981E3",
    fillRule: "evenodd",
    d: "M110.679 56.347a6.36 6.36 0 0 1-5.245 2.763 6.38 6.38 0 0 1-5.262-2.782c.67-.322 2.466-1.075 5.19-1.475v-.011l.041.005.041-.005v.011c2.792.413 4.606 1.195 5.235 1.494",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D7259",
    fillRule: "evenodd",
    d: "M106.738 53.2h-2.627v2.377c0 .682.588 1.234 1.314 1.234.725 0 1.313-.552 1.313-1.234zM108.051 52.063a.51.51 0 0 0-.515-.505h-4.223a.51.51 0 0 0-.515.505v.304c0 .279.23.505.515.505h4.223a.51.51 0 0 0 .515-.505z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9075",
    fillRule: "evenodd",
    d: "M107.72 50.298c.025-.352-.094-.7-.328-.96a1.22 1.22 0 0 0-.908-.406h-2.117c-.344 0-.673.147-.908.406-.234.26-.354.606-.329.96l.236 3.363c.046.666.587 1.18 1.236 1.18h1.644c.651 0 1.19-.514 1.237-1.18z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E3F2E",
    fillRule: "evenodd",
    d: "M107.72 50.298c.025-.353-.094-.7-.328-.96-.672-1.018-3.198-.94-3.933 0-.234.26-.354.605-.329.96l.135 1.917s.354 0 .354-.657 0-1.642.983-1.642c.626.45 1.232.435 1.644 0 .985 0 .985.821.985 1.642 0 .82.354.657.354.657z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E3E32",
    fillRule: "evenodd",
    d: "M106.497 51.986a.2.2 0 0 0-.052-.127.18.18 0 0 0-.253 0 .18.18 0 0 0-.052.127v.286c0 .047.02.093.052.125a.18.18 0 0 0 .253 0 .18.18 0 0 0 .052-.125zm-1.79 0a.2.2 0 0 0-.052-.127.18.18 0 0 0-.128-.051.18.18 0 0 0-.127.051.18.18 0 0 0-.051.127v.286c0 .047.019.093.051.125a.18.18 0 0 0 .127.05.2.2 0 0 0 .128-.05.18.18 0 0 0 .052-.125z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E3E32",
    d: "M105.425 53.703c-.414 0-.81-.151-1.117-.428a.1.1 0 0 1-.005-.143.105.105 0 0 1 .145-.008c.268.242.615.375.977.375.361 0 .708-.133.976-.375a.1.1 0 0 1 .145.008.1.1 0 0 1-.005.144 1.66 1.66 0 0 1-1.116.427"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 80.78a3 3 0 0 1-3-3V46.2a3 3 0 0 1 3-3h23.486a3 3 0 0 1 3 3v31.58a3 3 0 0 1-3 3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9ED",
    d: "M46.628 71.314c0-1.136.921-2.057 2.057-2.057h22.63a2.057 2.057 0 1 1 0 4.114h-22.63a2.057 2.057 0 0 1-2.057-2.057M46.628 78.857c0-1.136.921-2.057 2.057-2.057h6.858a2.057 2.057 0 0 1 0 4.114h-6.858a2.057 2.057 0 0 1-2.057-2.057M69.257 78.857a2.057 2.057 0 1 1 4.114 0 2.057 2.057 0 0 1-4.114 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89A8F8",
    d: "M52.114 63.772c0-1.137.921-2.058 2.057-2.058H67.2a2.057 2.057 0 1 1 0 4.115H54.17a2.057 2.057 0 0 1-2.057-2.057"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9ED",
    d: "M93.983 69.795c0-.958.777-1.734 1.734-1.734h19.079a1.735 1.735 0 1 1 0 3.468H95.717a1.734 1.734 0 0 1-1.734-1.734M93.983 76.155c0-.958.777-1.735 1.734-1.735h5.782a1.734 1.734 0 1 1 0 3.47h-5.781a1.735 1.735 0 0 1-1.735-1.735M113.062 76.155a1.735 1.735 0 1 1 3.47 0 1.735 1.735 0 0 1-3.47 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89A8F8",
    d: "M98.608 63.435c0-.958.777-1.734 1.735-1.734h10.985a1.734 1.734 0 0 1 0 3.469h-10.985a1.734 1.734 0 0 1-1.735-1.735"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9ED",
    d: "M3.469 69.795c0-.958.776-1.734 1.734-1.734h19.08a1.734 1.734 0 0 1 0 3.468H5.202a1.734 1.734 0 0 1-1.734-1.734M3.469 76.155c0-.958.776-1.735 1.734-1.735h5.782a1.734 1.734 0 1 1 0 3.47H5.203a1.734 1.734 0 0 1-1.734-1.735M22.548 76.155a1.734 1.734 0 1 1 3.469 0 1.734 1.734 0 0 1-3.47 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89A8F8",
    d: "M8.094 63.435c0-.958.777-1.734 1.734-1.734h10.985a1.735 1.735 0 0 1 0 3.469H9.828a1.734 1.734 0 0 1-1.734-1.735"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#BED1FF",
    fillRule: "evenodd",
    d: "M21.655 52.801c0 1.3-.412 2.506-1.12 3.494a6.43 6.43 0 0 1-5.248 2.676 6.42 6.42 0 0 1-5.265-2.7 5.97 5.97 0 0 1-1.108-3.472c0-3.407 2.856-6.17 6.371-6.17 3.514 0 6.37 2.763 6.37 6.172",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA663E",
    fillRule: "evenodd",
    d: "M12.75 57.637s-.133-2.576-.347-6.345c0 0-.909-3.212 1.985-3.638 0 0 3.885-.665 3.914 2.83.033 4.076-.637 5.883-.282 7.253.354 1.373-5.27-.1-5.27-.1",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#5981E3",
    fillRule: "evenodd",
    d: "M20.649 56.24a6.56 6.56 0 0 1-5.356 2.731 6.55 6.55 0 0 1-5.373-2.755c.685-.314 2.518-1.06 5.3-1.456v-.011l.042.005.041-.005v.011c2.852.408 4.703 1.176 5.346 1.48",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1AA8B",
    fillRule: "evenodd",
    d: "M16.626 53.125h-2.683v2.352c0 .674.6 1.22 1.342 1.22.74 0 1.34-.546 1.34-1.22z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FACAAF",
    fillRule: "evenodd",
    d: "M17.628 50.254a1.26 1.26 0 0 0-1.262-1.352h-2.163c-.35 0-.686.146-.927.402-.239.257-.36.6-.335.95.073 1.006.172 2.365.24 3.326.048.658.6 1.169 1.263 1.169h1.679c.665 0 1.215-.51 1.262-1.17z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA663E",
    fillRule: "evenodd",
    d: "M13.68 51.103c-.636.033-1 .073-1 .073-.643-3.706 2.913-3.228 2.913-3.228 2.797-.038 2.348 3.204 2.348 3.204-1.565-.11-2.91-.1-3.85-.065-.002-.748.008-1.686.008-1.686-.307.55-.396 1.243-.418 1.702",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#631F0A",
    fillRule: "evenodd",
    d: "M16.379 51.924a.18.18 0 0 0-.053-.126.2.2 0 0 0-.129-.05.2.2 0 0 0-.129.05.17.17 0 0 0-.053.126v.283c0 .047.02.091.053.123.035.034.082.051.13.051a.2.2 0 0 0 .128-.05.17.17 0 0 0 .053-.124zm-1.828 0a.18.18 0 0 0-.053-.126.2.2 0 0 0-.13-.05.2.2 0 0 0-.13.05.17.17 0 0 0-.053.126v.283c0 .047.02.091.053.123q.056.051.13.051a.2.2 0 0 0 .13-.05.17.17 0 0 0 .053-.124z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#631F0A",
    d: "M15.285 53.623c-.422 0-.827-.15-1.14-.424a.1.1 0 0 1-.006-.142.11.11 0 0 1 .149-.008c.274.24.627.371.997.371s.723-.13.997-.37a.107.107 0 0 1 .148.007.1.1 0 0 1-.006.142 1.72 1.72 0 0 1-1.14.424"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "DocumentVerify_svg__a",
    width: 54.972,
    height: 64.572,
    x: 32.514,
    y: 37.772,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 6,
    result: "effect1_dropShadow_9126_2657"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9126_2657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9126_2657",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentVerify);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "733380c8fec646263ba4e3b2bea8142d.svg";